import { IconProps } from '../../utils/icon';
import { Svg } from '../../utils/IconBase';

const IconEditSmallLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.5 16.262h1.261l4.998-4.998-1.261-1.262L7.5 15v1.262Zm-.596 1.5a.874.874 0 0 1-.644-.26.874.874 0 0 1-.26-.644v-1.733a1.8 1.8 0 0 1 .527-1.275l7.425-7.42c.15-.137.318-.243.5-.317A1.5 1.5 0 0 1 15.027 6c.2 0 .395.036.583.107.188.07.354.184.5.34l1.22 1.236c.156.145.266.311.332.5.066.188.1.377.1.565 0 .201-.035.393-.104.576-.069.183-.178.35-.328.501l-7.418 7.41a1.8 1.8 0 0 1-1.276.527H6.904Zm6.213-7.118-.62-.642 1.262 1.261-.642-.62Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconEditSmallLine;
